const reactEnv: string =
	process.env.REACT_APP_NODE_ENV !== undefined
		? process.env.REACT_APP_NODE_ENV.toString()
		: 'DEV'

const config = {
	// env
	env: process.env.REACT_APP_NODE_ENV,
	isDevEnv: process.env.REACT_APP_NODE_ENV?.toString().toUpperCase() !== 'PROD',

	// system
	system: {
		name: process.env.REACT_APP_SYSTEM_NAME,
		subtitle: process.env.REACT_APP_SYSTEM_SUBTITLE,
		baseUrl: process.env[`REACT_APP_${reactEnv}_BASE_URL`],
	},

	// aws
	aws: {
		access_key_id: '',
		secret_access_key: '',
		region: {
			default: 'ap-northeast-2',
			sms: 'us-east-1',
		},
		smtpUsername: 'nexetcorp',
		ses_noreply_email: 'noreply@judahs.io',
	},

	// paypal
	paypal: {
		clientId:
			process.env.REACT_APP_PAYPAL_ENV === 'DEV'
				? process.env.REACT_APP_PAYPAL_DEV_CLIENT_ID
				: process.env.REACT_APP_PAYPAL_PROD_CLIENT_ID,
		enableFunding: '',
		disableFunding: '',
		currency: 'USD',
		dataPageType: 'product-details',
		components: 'buttons',
		dataSdkIntegrationSource: 'developer-studio',
		environment: process.env.REACT_APP_PAYPAL_ENV === 'DEV' ? 'sandbox' : 'production', // sandbox | production
	},
}

export default config
